import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`] || color;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1791_107799)">
        <path
          d="M9.99979 5C4.96478 5 0.833496 9.13129 0.833496 14.1663H2.12452C2.12452 9.84135 5.67485 6.29103 9.99979 6.29103C14.3247 6.29103 17.8751 9.84135 17.8751 14.1663H19.1661C19.2306 9.13129 15.0993 5 9.99979 5Z"
          fill={colorValue}
        />
        <path
          d="M10.7741 13.5852L12.5816 9.58301L8.5794 11.3904C8.06299 11.6487 7.74023 12.2296 7.74023 12.8106C7.74023 13.7143 8.4503 14.4244 9.35402 14.4244C9.99953 14.4244 10.5159 14.1016 10.7741 13.5852Z"
          fill={colorValue}
        />
      </g>
      <defs>
        <clipPath id="clip0_1791_107799">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
